// extracted by mini-css-extract-plugin
module.exports = {"DesignStudio":"styles_DesignStudio__9kLeA","logo":"styles_logo__ss9_i"};